import { Alert, Button, CardActions, Stack, Box } from "@mui/material";
import * as moment from "moment";
import "moment/locale/fr";
import ContractUserDialog from "../modules/Contracts/ContractUserDialog";
import { Contract, ContractStatus, Status } from "../models/ContractTypes";
import { ServiceResponse } from "../models/ServiceTypes";
import { useState } from "react";
import ArchivagePopupMessage from "./ArchivagePopupMessage";
import { WorkspaceStatusResponse } from "../models/SharePointTypes";

export interface ActionWorkspaceButtonConfig {
  type: Status;
  label: string;
  onClick: () => void;
  successMessage: string;
}

interface ActionWorkspaceButtonProps {
  config: ActionWorkspaceButtonConfig;
  responseLocalStatus?: ContractStatus[];
  responseCodeSp?: ServiceResponse;
  responseGetWorkspaceStatus?: WorkspaceStatusResponse;
  choosenContractOne: Contract;
  currentUser: any;
}

const ActionWorkspaceButton = ({
  config,
  responseLocalStatus,
  responseCodeSp,
  responseGetWorkspaceStatus,
  choosenContractOne,
  currentUser,
}: ActionWorkspaceButtonProps) => {

  const hasNoStatus = responseLocalStatus?.length === 0;
  const hasCodeSp = responseCodeSp?.code_sp != null;
  const hasStatus = responseLocalStatus?.length !== 0;
  const [openArchivagePopup, setOpenArchivagePopup] = useState(false);

  /*CREER*/
  const isCreateMessageEnable =
    config.type === "CREER" &&
    hasStatus &&
    responseLocalStatus?.[0]?.status === "CREER"
      ? true
      : false;
  const isCreateButtonEnabled =
    config.type === "CREER" && hasNoStatus ? true : false;

  /*ARCHIVER*/
  const isArchiverMessageEnable =
    config.type === "ARCHIVER" &&
    hasStatus &&
    responseLocalStatus?.[0]?.status === "ARCHIVER"
      ? true
      : false;

  const isArchiverButtonEnable =
    config.type === "ARCHIVER" &&
    responseGetWorkspaceStatus?.buttonToEnable &&
    responseGetWorkspaceStatus?.buttonToEnable === "ARCHIVER" &&
    hasCodeSp &&
    !isArchiverMessageEnable;

  /*RESTAURER*/
  const isRestaurerMessageEnable =
    config.type === "RESTAURER" &&
    hasStatus &&
    responseLocalStatus?.[0]?.status === "RESTAURER"
      ? true
      : false;
  const isRestaurerButtonEnable =
    config.type === "RESTAURER" &&
    responseGetWorkspaceStatus?.buttonToEnable &&
    responseGetWorkspaceStatus?.buttonToEnable === "RESTAURER" &&
    hasCodeSp &&
    !isRestaurerMessageEnable;

  function handleArchivagePopupOpen() {
    setOpenArchivagePopup(true);
  }

  function handleArchivagePopupClosed() {
    setOpenArchivagePopup(false);
  }

  function handleAgreeButton() {
    config.onClick();
    handleArchivagePopupClosed();
  }

  function renderMessageInfo() {
    return (
      <Stack sx={{ width: '50%' }} spacing={2}>
        {responseGetWorkspaceStatus?.messageToShow && (
        <Alert severity="info" sx={{ whiteSpace: 'pre-line' }}>
          {responseGetWorkspaceStatus?.messageToShow}
        </Alert>
        )}        
        <Alert severity="success">
          {config.successMessage} {responseLocalStatus?.[0]?.created_by} le{" "}
          {moment.locale("fr") &&
            moment(responseLocalStatus?.[0]?.updated).format("LLL")}{" "}
        </Alert>
      </Stack>
    );
  }

  return (
    <CardActions sx={{ justifyContent: 'space-between', alignItems: 'center' }}>

      <Stack direction="column" spacing={1}>
        {isCreateMessageEnable && (
          <ContractUserDialog
            currentProjectId={choosenContractOne.projectId}
            currentServiceId={choosenContractOne.serviceId}
            currentUserName={currentUser.displayName}
          />
        )}
        {config.type === "CREER" && isCreateButtonEnabled && hasCodeSp && (
          <Button
            variant="contained"
            size="small"
            type="submit"
            onClick={config.onClick}
            sx={{
              color: "background.paper",
              borderColor: "background.paper",
            }}
          >
            {config.label}
          </Button>
        )}
        {isRestaurerButtonEnable && (
          <Button
            variant="contained"
            size="small"
            type="submit"
            onClick={config.onClick}
            sx={{
              color: "background.paper",
              borderColor: "background.paper",
            }}
          >
            {config.label}
          </Button>
        )}
        {isArchiverButtonEnable && (
          <>
            <Button
              variant="contained"
              size="small"
              type="submit"
              onClick={handleArchivagePopupOpen}
              sx={{
                color: "background.paper",
                borderColor: "background.paper",
              }}
            >
              {config.label}
            </Button>
            <ArchivagePopupMessage
              openPopup={openArchivagePopup}
              handleAgreeButton={handleAgreeButton}
              handleDesagreeButton={handleArchivagePopupClosed}
            />
          </>
        )}
      </Stack>
        
        {(isCreateMessageEnable ||
        isArchiverMessageEnable ||
        isRestaurerMessageEnable) ? (
        <>{renderMessageInfo()}</>
      ) : (
        <Box /> //un <Box /> vide quand il n'y a pas de messages pour maintenir l'alignement
      )}
    </CardActions>
  );
};

export default ActionWorkspaceButton;
